<div
  class="font-lato flex w-full rounded-xl bg-red-50 px-6 py-4 text-sm font-semibold text-red-600"
  [ngClass]="{
    'bg-red-50 text-red-600': status == 'warning',
    'bg-green-700/5 text-green-700': status == 'success',
  }"
>
  {{ message }}
</div>
